import { z } from 'zod'

import { RailLegIdZ, RailPassengerIdZ, RailSeatPreferenceGroupIdZ } from './common'

export const RailSeatPreferenceCarriageTypeIdZ = z.string().brand<'RailSeatPreferenceCarriageTypeId'>()

export type RailSeatPreferenceCarriageTypeId = z.infer<typeof RailSeatPreferenceCarriageTypeIdZ>

export const RailSeatPreferenceDeckIdZ = z.string().brand<'RailSeatPreferenceDeckId'>()

export type RailSeatPreferenceDeckId = z.infer<typeof RailSeatPreferenceDeckIdZ>

export const RailSeatPreferenceDirectionIdZ = z.string().brand<'RailSeatPreferenceDirectionId'>()

export type RailSeatPreferenceDirectionId = z.infer<typeof RailSeatPreferenceDirectionIdZ>

export const RailSeatPreferenceFacilityIdZ = z.string().brand<'RailSeatPreferenceFacilityId'>()

export type RailSeatPreferenceFacilityId = z.infer<typeof RailSeatPreferenceFacilityIdZ>

export const RailSeatPreferencePositionIdZ = z.string().brand<'RailSeatPreferencePositionId'>()

export type RailSeatPreferencePositionId = z.infer<typeof RailSeatPreferencePositionIdZ>

export const RailSeatPreferenceSelectionIdZ = z.string().brand<'RailSeatPreferenceSelectionId'>()

export type RailSeatPreferenceSelectionId = z.infer<typeof RailSeatPreferenceSelectionIdZ>

export const RailSeatPreferenceTypeIdZ = z.string().brand<'RailSeatPreferenceTypeId'>()

export type RailSeatPreferenceTypeId = z.infer<typeof RailSeatPreferenceTypeIdZ>

export const RailSeatPreferenceCarriageTypeZ = z.strictObject({
	description: z.string(),
	id: RailSeatPreferenceCarriageTypeIdZ,
})

export type RailSeatPreferenceCarriageTypeZ = z.infer<typeof RailSeatPreferenceCarriageTypeZ>

export const RailSeatPreferenceDeckZ = z.strictObject({
	description: z.string(),
	id: RailSeatPreferenceDeckIdZ,
})

export type RailSeatPreferenceDeck = z.infer<typeof RailSeatPreferenceDeckZ>

export const RailSeatPreferenceDirectionZ = z.strictObject({
	description: z.string(),
	id: RailSeatPreferenceDirectionIdZ,
})

export type RailSeatPreferenceDirection = z.infer<typeof RailSeatPreferenceDirectionZ>

export const RailSeatPreferenceFacilityZ = z.strictObject({
	description: z.string(),
	id: RailSeatPreferenceFacilityIdZ,
})

export type RailSeatPreferenceFacilityZ = z.infer<typeof RailSeatPreferenceFacilityZ>

export const RailSeatPreferenceLocationZ = z.strictObject({
	coach_number: z.string(),
	seat_number: z.string(),
})

export type RailSeatPreferenceLocationZ = z.infer<typeof RailSeatPreferenceLocationZ>

export const RailSeatPreferencePositionZ = z.strictObject({
	description: z.string(),
	id: RailSeatPreferencePositionIdZ,
})

export type RailSeatPreferencePosition = z.infer<typeof RailSeatPreferencePositionZ>

export const RailSeatPreferenceSelectionZ = z.strictObject({
	description: z.string(),
	id: RailSeatPreferenceFacilityIdZ,
})

export type RailSeatPreferenceSelection = z.infer<typeof RailSeatPreferenceSelectionZ>

export const RailSeatPreferenceTypeZ = z.strictObject({
	description: z.string(),
	id: RailSeatPreferenceTypeIdZ,
})

export type RailSeatPreferenceTypeZ = z.infer<typeof RailSeatPreferenceTypeZ>

export const RailSeatPreferenceGroupZ = z.strictObject({
	carriage_type: z.array(RailSeatPreferenceCarriageTypeZ),
	deck: z.array(RailSeatPreferenceDeckZ),
	direction: z.array(RailSeatPreferenceDirectionZ),
	facilities: z.array(RailSeatPreferenceFacilityZ),
	id: RailSeatPreferenceGroupIdZ,
	leg_ids: z.array(RailLegIdZ),
	passenger_ids: z.array(RailPassengerIdZ),
	position: z.array(RailSeatPreferencePositionZ),
	seat_map_is_available: z.boolean(),
	selection: z.array(RailSeatPreferenceSelectionZ),
	type: z.array(RailSeatPreferenceTypeZ),
})

export type RailSeatPreferenceGroup = z.infer<typeof RailSeatPreferenceGroupZ>

export const RailSelectedSeatPreferenceZ = z.strictObject({
	carriage_type_id: RailSeatPreferenceCarriageTypeIdZ.optional(),
	deck_id: RailSeatPreferenceDeckIdZ.optional(),
	direction_id: RailSeatPreferenceDirectionIdZ.optional(),
	facility_ids: z.array(RailSeatPreferenceFacilityIdZ).optional(),
	id: RailSeatPreferenceGroupIdZ,
	/** Available only if the `selection_id` is specified */
	location: RailSeatPreferenceLocationZ.optional(),
	position_id: RailSeatPreferencePositionIdZ.optional(),
	type_id: RailSeatPreferenceTypeIdZ.optional(),
	selection_id: RailSeatPreferenceSelectionIdZ.optional(),
})

export type RailSelectedSeatPreference = z.infer<typeof RailSelectedSeatPreferenceZ>

export const RailSelectedSeatPreferenceRequestZ = z.strictObject({
	seat_preferences: z.array(RailSelectedSeatPreferenceZ),
})
